export const EVENTS = {
    CHANGE: 'change',
};

export const SELECTORS = {
    SLOT: 'slot',
};

export const CHILD_TAGS = {
    RADIO_OPTION: 'SOTBIT-RADIO-OPTION',
    RADIO_OPTION_BUTTOM: 'SOTBIT-RADIO-OPTION-BUTTON',
};
